import { render, staticRenderFns } from "./PAF03.vue?vue&type=template&id=788eb828&scoped=true&"
import script from "./PAF03.vue?vue&type=script&lang=js&"
export * from "./PAF03.vue?vue&type=script&lang=js&"
import style0 from "./PAF03.vue?vue&type=style&index=0&id=788eb828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788eb828",
  null
  
)

export default component.exports